<template>
  <b-container>
    <b-card class="mt-2" title="All trades">
      <b-table class="table-dark" striped hover :fields="fields" :items="items">
        <template v-slot:cell(id)="data">
          <router-link :to="`/trade/${data.value}`">{{
            data.value
          }}</router-link>
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>
/*
    Full swap to something realistic to display.
*/
function parseSwap(swap) {
  let legs = swap.legs;

  // e.g. Pay fix 0.0023 P6M
  let payLeg = legs.filter(leg => leg.payReceive == "Pay")[0];

  // e.g. Rec TAIBOR6M
  let recLeg = legs.filter(leg => leg.payReceive == "Receive")[0];

  return {
    id: swap.id,
    counterparty: swap.counterparty,
    startDate: payLeg.accrualSchedule.startDate,
    endDate: payLeg.accrualSchedule.endDate,
    payLeg: parseLeg(payLeg),
    recLeg: parseLeg(recLeg)
  };
}

function parseLeg(leg) {
  let legType = leg.payReceive;
  if (leg.calculation.calculationType == "IborRateCalculation") {
    return `${legType} ${leg.calculation.index} ${leg.accrualSchedule.frequency}`;
  } else {
    return `${legType} ${leg.calculation.rate} ${leg.accrualSchedule.frequency}`;
  }
}

export default {
  data() {
    return {
      fields: [
        { key: "id", sortable: true },
        { key: "counterparty", sortable: true },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true },
        { key: "payLeg", sortable: true },
        { key: "recLeg", sortable: true }
      ],
      items: []
    };
  },
  async mounted() {
    let resp = await this.$client.getTrades();
    this.items = resp.map(parseSwap);
    // let tradeId = "swap~1"; // String | The user ID
  }
};
</script>
